import Button from "../../components/Button";
import { convertToRupiah } from "../../helper/RupiahDashboard";

const WorkerItem = ({ no, data, handleDeposit, handleBpjs }) => {

  return (
    <tr>
      <td>{no}</td>
      <td>{data.user_id}</td>
      <td>{data.name}</td>
      <td>{data.type}</td>
      <td>{data.bank_code}</td>
      <td>{data.bank_account_name}</td>
      <td>{data.bank_account}</td>
      <td>{data.email}</td>
      <td>
        <div className="flex justify-content-between">
          <span>{data.amount ? `Rp. ${convertToRupiah(data.amount)}` : "Rp. 0"}</span>
          <Button
            icon="fa fa-wrench"
            button="btn btn-warning btn-sm"
            onClick={() => handleDeposit(data)}
          />
        </div>
      </td>
      <td>
        <Button
          icon="fa fa-history"
          button="btn-info btn-sm"
          onClick={() => handleBpjs(data)}
        />
      </td>
    </tr>
  );
};

export default WorkerItem;
